import { TEXT_KEYS } from '../../constants/textKeys';
import { t } from '../../translation/translation';
import './style.css'

export const PrivacPolicy = () => {

    return (
        <div className='type-policy-container page-container'>
            <h3>{t(TEXT_KEYS.PRIVACY_POLICY_TITLE)}</h3>
            <div className='type-policy-container-policy'>
                <h4>{t(TEXT_KEYS.PRIVACY_POLICY_TITLE_1)}</h4>
                <p>{t(TEXT_KEYS.PRIVACY_POLICY_DESCRIPTION_1)}</p>
                <h4>{t(TEXT_KEYS.PRIVACY_POLICY_TITLE_2)}</h4>
                <p>{t(TEXT_KEYS.PRIVACY_POLICY_DESCRIPTION_2)}</p>
                <h4>{t(TEXT_KEYS.PRIVACY_POLICY_TITLE_3)}</h4>
                <p>{t(TEXT_KEYS.PRIVACY_POLICY_DESCRIPTION_3)}</p>
                <h4>{t(TEXT_KEYS.PRIVACY_POLICY_TITLE_4)}</h4>
                <p>{t(TEXT_KEYS.PRIVACY_POLICY_DESCRIPTION_4)}</p>
            </div>
        </div>
    );
}